






















export default {
    name: 'SearchInputLayout',
};
